import styled from "styled-components";

/** Libraries */
import { IconButton } from "@libraries/mui";

import { windowWidth } from "@styles/global";

const Container = styled.div`
  padding: 0 30px;

  > :not(:last-child) {
    margin-bottom: 15px;
  }

  @media (max-width: ${windowWidth.mobile.large}) {
    padding-left: 15px;
    padding-right: 15px;

    /** step tabs and control buttons */
    :nth-child(2),
    :last-child {
      padding-left: 1px;
      padding-right: 1px;
    }
  }
`;

const MessagesButtonContainer = styled.div`
  position: fixed;
  bottom: 16px;
  margin-bottom: 15px;

  @media (max-width: ${windowWidth.mobile.large}) {
    left: 16px;
  }
`;

const MessagesButton = styled(IconButton)`
  color: ${({ theme }) => theme.colors.primary} !important;
`;

export { Container, MessagesButtonContainer, MessagesButton };
